import { UserFile, UserTask } from '__generated__/api-types-and-hooks'
import { AppDeleteFile } from 'components/AppKanbanBoard/AppDeleteFile/AppDeleteFile.component'
import { AppFileCard } from 'components/Common/AppFileCard/AppFileCard.component'
import React, { useState } from 'react'

interface IAppTaskFileCardProps {
  file: UserFile
  task?: UserTask
  onDelete?: () => void
  isDeletable?: boolean
  refetch?: () => void
  success?: boolean
  onDeleteSuccess?: (success: boolean) => void
}

export const AppTaskFileCard = ({
  file,
  onDelete,
  isDeletable,
  task,
  refetch,
  success,
  onDeleteSuccess,
}: IAppTaskFileCardProps) => {
  const [showDeleteFileModal, setShowDeleteFileModal] = useState(false)
  // retained states and logic removed in favor of AppFileCard

  return (
    <div>
      <AppFileCard
        file={file}
        showRemove={!!isDeletable}
        onRemove={() => {
          setShowDeleteFileModal(true)
        }}
      />
      {showDeleteFileModal && (
        <AppDeleteFile
          task={task}
          file={file}
          onCancel={() => {
            setShowDeleteFileModal(false)
          }}
          onDelete={(success) => {
            if (success) {
              onDeleteSuccess?.(true)
            } else {
              onDeleteSuccess?.(false)
            }
            setShowDeleteFileModal(false)
          }}
        />
      )}
    </div>
  )
}
